import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CuttingMatBaseFurniture } from '../models/cutting/cutting-mat-base-furniture.model';
import { CuttingMatBaseGroup, TypeGroupMaterial } from '../models/cutting/cutting-material-group.model';
import { CuttingMaterial } from '../models/cutting/cutting-material.model';
import { CuttingMatBaseDialogService } from '../modules/cutting-material-base-dialog/cutting-material-base-dialog.service';
import { ApiLinks } from '../modules/cutting-panel-list/csl.api-links';

// TODO: Сервис для cutting'а не должен быть в cloud-shared-lib
@Injectable()
export class CuttingMaterialBaseService implements CuttingMatBaseDialogService {
  constructor(
    private http: HttpClient //
  ) {}

  onMaterialGroupsChanged: BehaviorSubject<CuttingMatBaseGroup[]> = new BehaviorSubject([]);
  materialsTotlaCount = 0;

  onFurnitureGroupsChanged: BehaviorSubject<CuttingMatBaseGroup[]> = new BehaviorSubject([]);
  onFurnitureListChanged: BehaviorSubject<CuttingMatBaseFurniture[]> = new BehaviorSubject([]);
  furnituresTotlaCount = 0;

  getGroups(groupType: TypeGroupMaterial[], forOrderPanel = false): Observable<CuttingMatBaseGroup[]> {
    let params = new HttpParams();

    groupType.forEach(g => {
      params = params.append('groupType', g.toString());
    });
    params = params.set('forOrderPanel', forOrderPanel);

    return this.http.get<CuttingMatBaseGroup[]>(ApiLinks.materialGroup, { params: params });
  }

  getMaterials(
    groupId: number,
    pageSize: number,
    pageIndex: number,
    filterText: string,
    priceFrom: number,
    priceTo: number,
    priceSort: SortDirection,
    forOrderPanel = false
  ): Observable<{ data: CuttingMaterial[]; totalCount: number }> {
    const searchParams: HttpParams = new HttpParams()
      .set('groupId', groupId.toString())
      .set('pageSize', pageSize.toString())
      .set('pageIndex', pageIndex.toString())
      .set('filterText', filterText)
      .set('priceFrom', _.isNil(priceFrom) ? priceFrom : priceFrom.toString())
      .set('priceTo', _.isNil(priceTo) ? priceTo : priceTo.toString())
      .set('priceSort', priceSort)
      .set('forOrderPanel', forOrderPanel);

    return this.http.get(ApiLinks.material, { params: searchParams }).pipe(
      map((response: { materialsDTO: CuttingMaterial[]; materialsCount: number }) => {
        return {
          totalCount: response.materialsCount,
          data: response.materialsDTO,
        };
      })
    );
  }

  getFurnitures(
    groupId: number,
    pageSize: number,
    pageIndex: number,
    filterText: string
  ): Promise<CuttingMatBaseFurniture[]> {
    if (+groupId <= 0 && +pageIndex < 0 && +pageSize <= 0) {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }

    const searchParams: HttpParams = new HttpParams()
      .set('groupId', groupId.toString())
      .set('pageSize', pageSize.toString())
      .set('pageIndex', pageIndex.toString())
      .set('filterText', filterText);

    return new Promise((resolve, reject) => {
      this.http
        .get(ApiLinks.matBaseFurniture, { params: searchParams })
        .pipe(
          map((response: { furnituresDTO: CuttingMatBaseFurniture[]; furnituresCount: number }) => {
            this.furnituresTotlaCount = response.furnituresCount;
            return response.furnituresDTO;
          })
        )
        .subscribe(
          (response: any[]) => {
            this.onFurnitureListChanged.next(response);
            resolve(response);
          },
          () => {
            this.onFurnitureGroupsChanged.next([]);
            resolve([]);
          }
        );
    });
  }

  getFurnitureGroups(): Promise<CuttingMatBaseGroup[]> {
    return new Promise((resolve, reject) => {
      this.http.get<CuttingMatBaseGroup[]>(ApiLinks.matBaseFurnitureGroup).subscribe((g: CuttingMatBaseGroup[]) => {
        this.onFurnitureGroupsChanged.next(g);

        resolve(g);
      }, reject);
    });
  }
}
